"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));
var _appConfigHelper = require("./appConfigHelper");
var _package = require("../../package.json");
/* eslint-disable camelcase */

const environment = (0, _appConfigHelper.getData)('CLEENG_ENVIRONMENT');
const PROD_TOKEN = 'b0295127740fa6adee7c1e57995a2073';
const STG_TOKEN = '58fd0d2785acbde61a6c117a642c0360';
const MIXPANEL_TOKEN = environment === 'production' ? PROD_TOKEN : STG_TOKEN;
_mixpanelBrowser.default.init(MIXPANEL_TOKEN);
const trackMixpanelEvent = (eventName, eventData) => {
  if (environment === 'production' || environment === 'staging') {
    _mixpanelBrowser.default.track(eventName, {
      ...eventData,
      version: _package.version
    });
  }
};
var _default = exports.default = trackMixpanelEvent;